var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.11 93.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ICON",
    className: "cls-1",
    d: "M53.02,88.37c.02-2.41,1.83-4.44,4.22-4.75l.57-.03h37.21c2.62-.18,4.9,1.79,5.08,4.42s-1.79,4.9-4.42,5.08l-.57.04h-37.22c-2.65.02-4.83-2.1-4.87-4.76ZM4.91,93.12c-1.33,0-2.6-.52-3.54-1.46-.91-.9-1.41-2.15-1.37-3.43l.53-20.98c.13-4.34,1.96-8.46,5.1-11.46L57.99,5.25c7.37-6.99,18.92-6.99,26.28,0l7,6.75c7.03,6.7,7.3,17.83.6,24.86-.2.2-.4.4-.6.6l-52.56,50.75c-3.3,3.18-7.71,4.94-12.29,4.92H4.91ZM64.93,12.01l-3.09,2.97,19.4,18.72,3.12-3.01c3.3-3.13,3.43-8.33.31-11.63-.1-.11-.2-.21-.31-.31l-6.99-6.75c-3.48-3.32-8.96-3.32-12.45,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEditar);
export default __webpack_public_path__ + "static/media/logo_editar.e5c31ddf2876937ec9104b50f50c3e49.svg";
export { ForwardRef as ReactComponent };